import { Button, Modal } from 'antd';
import { t } from 'i18next';
import QRCode from 'qrcode.react';

const ModalQRcode = ({ open, handelClose, loading, qrPath = '' }) => {
    const downloadQRCode = () => {
        // Generate download with use canvas and stream
        const canvas = document.getElementById('qr-gen');
        const pngUrl = canvas
            .toDataURL('image/png')
            .replace('image/png', 'image/octet-stream');
        let downloadLink = document.createElement('a');
        downloadLink.href = pngUrl;
        downloadLink.download = `myQrCode.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    return (
        <Modal
            width={450}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-12 text-center">
                <div>
                    <QRCode id="qr-gen" size={200} value={qrPath} level={'H'} />
                </div>
            </div>
            <div className="flex justify-center items-center space-x-4">
                <Button
                    type="primary"
                    onClick={handelClose}
                    size="large"
                    className="w-40"
                    ghost
                >
                    {t('common.Cancel')}
                </Button>
                <Button
                    className="w-40"
                    loading={loading}
                    onClick={downloadQRCode}
                    size="large"
                    type="primary"
                >
                    {t('common.DownloadQR')}
                </Button>
            </div>
        </Modal>
    );
};
export default ModalQRcode;
